module.exports = __webpack_public_path__ + "static/media/StAndrews.b2b35fbf.jpg";